import { joinParts } from './utils'

export const payments = {
  refund: (codeTransaction?: string) => joinParts('payments', 'refund', codeTransaction),
}
